import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TrainingProgram, TrainingProgramCreate, TrainingProgramFilter } from '../data/trainingProgram';

export function createTrainingProgramService(client: AxiosInstance) {
  return createCrudService<TrainingProgram, TrainingProgramCreate, TrainingProgramFilter>(
    client,
    '/hrm/TrainingProgram',
    'id',
  );
}

export type TrainingProgramService = CrudService<TrainingProgram, TrainingProgramCreate, TrainingProgramFilter>;
